// extracted by mini-css-extract-plugin
export default {"heading":"NotFoundPage_heading__ySEMB","title":"NotFoundPage_title__4G8FX","description":"NotFoundPage_description__Wkftx"};